module.exports = __webpack_public_path__ + "static/media/face-5.de26a134.jpeg";